<template>
    <div class="btn btn-xs btn-warning" :disabled="deleter.submitted" @click="confirm()">Ta bort</div>
</template>

<script>

import deleter from '../../../../shared/mixins/deleter'

export default {

    mixins: [
        deleter
    ],

    props: {
        clinic: {
            required: true
        },
        entry: {
            required: true
        }
    },

    computed: {
        deleterUrl () {
            return '/clinics/' + this.clinic.id + '/contactLog/' + this.entry.id
        }
    },

    methods: {
        confirm () {
            if (!window.confirm('Är du säker?')) {
                return
            }

            this.deleterDelete()
        },

        deleterSuccess (data) {
            this.$emit('deleted', data)
            bus.$emit('notify', 'Kontaktloggen togs bort.')
        }
    }

}
</script>
